import { defaultCountries, parseCountry, type CountryIso2 } from 'react-international-phone';

// Route fields currently store free text, not a geocoded place. Only infer
// unambiguous known cities or an explicit country; unknown places stay manual.
const routeCities: Partial<Record<CountryIso2, string[]>> = {
  ru: ['москва', 'moscow', 'сочи', 'sochi', 'санкт-петербург', 'спб', 'saint petersburg', 'калининград', 'kaliningrad', 'краснодар', 'krasnodar', 'нижний новгород', 'nizhny novgorod'],
  de: ['берлин', 'berlin', 'мюнхен', 'munich', 'münchen', 'гамбург', 'hamburg', 'кёльн', 'köln', 'cologne', 'франкфурт', 'frankfurt', 'франкфурт-на-майне', 'frankfurt am main'],
  kz: ['алматы', 'almaty', 'астана', 'astana'],
  by: ['минск', 'minsk'],
  ge: ['тбилиси', 'tbilisi', 'батуми', 'batumi'],
  am: ['ереван', 'yerevan'],
  tr: ['стамбул', 'istanbul', 'анталья', 'antalya'],
  fi: ['хельсинки', 'helsinki'],
  pl: ['варшава', 'warsaw', 'warszawa'],
  cz: ['прага', 'prague', 'praha'],
  rs: ['белград', 'belgrade', 'beograd'],
  hu: ['будапешт', 'budapest'],
  th: ['бангкок', 'bangkok'],
  fr: ['париж', 'paris'],
  gb: ['лондон', 'london'],
};
const normalize = (value: string) => value.trim().toLocaleLowerCase().replaceAll('ё', 'е');
const names = ['ru', 'en'].map(locale => new Intl.DisplayNames([locale], { type: 'region' }));

export function phoneCountryForCity(city: string): CountryIso2 | undefined {
  const parts = city.split(',').map(normalize).filter(Boolean);
  const countryName = parts.at(-1);
  for (const country of defaultCountries) {
    const { iso2 } = parseCountry(country);
    if (countryName === iso2 || names.some(names => normalize(names.of(iso2.toUpperCase()) || '') === countryName)) return iso2;
  }
  const matches = Object.entries(routeCities).filter(([, cities]) => cities?.some(name => normalize(name) === parts[0]));
  return matches.length === 1 ? matches[0][0] as CountryIso2 : undefined;
}
